import s from './BackgroundImageAuthPageBotPosition.module.css';

const BackgroundImageAuthPageBotPosition = () => {
  return <div className={s.backgroundImageBot} />;
};

export default BackgroundImageAuthPageBotPosition;
